import { Controller } from "@hotwired/stimulus"

// Shows/hides a pre-rendered ModalComponent (embedded: true) without a network round-trip.
export default class extends Controller {
  static targets = ["modal", "card"]

  connect() {
    this.closeWithKeyboardBound = this.closeWithKeyboard.bind(this)
    document.addEventListener("keydown", this.closeWithKeyboardBound)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeWithKeyboardBound)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event?.preventDefault()
    this.showModal()
  }

  close(event) {
    event?.preventDefault()
    this.hideModal()
  }

  closeBackground(event) {
    if (this.hasCardTarget) {
      const path = typeof event.composedPath === "function" ? event.composedPath() : []
      if (path.includes(this.cardTarget) || this.cardTarget.contains(event.target)) return
    }

    this.hideModal()
  }

  closeWithKeyboard(event) {
    if (event.code !== "Escape") return
    if (!this.hasModalTarget || this.modalTarget.classList.contains("hidden")) return

    this.hideModal()
  }

  showModal() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  hideModal() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
